// extracted by mini-css-extract-plugin
module.exports = {"default-arrows-container":"a10a3f92e9--default-arrows-container--tYj02","default-arrows-wrapper":"a10a3f92e9--default-arrows-wrapper--DVf21"};